import _ from 'lodash'

export default (entries) => entries.map((e) =>
    _.pick(e, [
        'id',
        'firstName',
        'lastName',
        'email',
        'gradYear',
        'jerseyNumber',
        'positions',
        'guardianEmail1',
        'guardianEmail2',
        'phoneNumber',
        'preCommitted',
    ])
)